import { computed } from "vue";
import { useTenantEntityManager } from "@/composables/useTenantManager.js";
import { sessionStatus as SESSION_STATUSES } from "@/components/program-manager/sessions/constants";

export const useSessionV2Filters = () => {
  const { getSelectedEntityView: selectedEntity } = useTenantEntityManager();
  const selectedEntityId = computed(() => selectedEntity?.value?.id);

  const mySessionsFilter = computed(() => {
    return `session.owner_entity_id:${selectedEntityId.value}`;
  });

  const catalogSessionsFilter = computed(() => {
    return `(session.status_id:${SESSION_STATUSES.openEnrollment} OR session.status_id:${SESSION_STATUSES.inSession}) AND (session.marketplace:true OR session.shared_with:${selectedEntityId.value}) AND NOT session.owner_entity_id:${selectedEntityId.value} AND NOT session.excluded_entity_ids:${selectedEntityId.value}`;
  });

  const hiddenSessionsFilter = computed(() => {
    return `session.excluded_entity_ids:${selectedEntityId.value}`;
  });

  return {
    mySessionsFilter,
    catalogSessionsFilter,
    hiddenSessionsFilter,
    selectedEntityId,
    selectedEntity,
  };
}
